// extracted by mini-css-extract-plugin
module.exports = {"badges":"badges_badges__1hTBV","badge_img":"badges_badge_img__2XqDE","br":"badges_br__2VOh3","sgw_layered_badge":"badges_sgw_layered_badge__Ie1-L","row":"badges_row__3ZfMP"};